// src/components/Business.js
import React from 'react';
import '../App.css';

const BusinessLogo = () => (
  <svg width="300" height="200" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="20" y="30" width="60" height="40" fill="#2E7D32" />
    <rect x="30" y="20" width="40" height="10" fill="#FFB300" />
    <path d="M20 70H80V80H20V70Z" fill="#1B5E20" />
    <rect x="35" y="40" width="10" height="20" fill="#F5F8F5" />
    <rect x="55" y="40" width="10" height="20" fill="#F5F8F5" />
  </svg>
);

const Business = () => (
  <section className="business-section">
    <div className="content-wrapper">
      <h2 className="section-title">FugiPay Business: Empowering Commerce</h2>
      <div className="business-flex">
        <div className="business-text">
          <p className="business-description">
            FugiPay Business brings seamless payment solutions to merchants and organizations in Zambia. Accept payments via NFC & QR codes, manage your finances, and settle instantly—all tailored for growth and efficiency.
          </p>
          <ul className="business-features">
            <li><span className="feature-icon">🏪</span> QR payments & NFC for in-store and online</li>
            <li><span className="feature-icon">⏰</span> Convenience advantages</li>
            <li><span className="feature-icon">💰</span> Instant settlements to your account</li>
          </ul>
          <p className="business-cta">
            Ready to grow? Sign up as a business today and start accepting payments with ease.
          </p>
          <div className="app-links">
            <a href="/" className="app-button ios">Get Started</a>
            <a href="mailto:prointbiz@gmail.com?subject=FugiPay%20Business%20Inquiry" className="app-button android">Contact Sales</a>
          </div>
        </div>
        <div className="business-image-wrapper">
          <BusinessLogo />
        </div>
      </div>
    </div>
  </section>
);

export default Business;